<template>
  <div class="popup-wrapper">
    <div class="popup-overlay" @click="closePopup('video')"></div>
    <div class="popup popup--video">
      <button class="popup-close2" @click="closePopup('video')"><i class="icon-close"></i> <span>Close player</span></button>
      <div class="video-box">
        <div class="video-wrapper">
          <div class="video-img-wrapper" v-html="videoIframe">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vimeo from "@/api/external/vimeo";

export default {
  props: ['videoLink', 'withoutPlayButton'],
  name: "SolutionVideoPopup",
  data() {
    return {
      thumbnail: '',
      popupVideo: true,
      videoIframe: ''
    }
  },
  mounted() {
    this.getVideoThumbnail()
  },
  methods: {
    closePopup () {
      this.popupVideo = 0
      document.querySelector('body').classList.remove('nooverflow')
      this.$emit('close')
    },
    getVideoThumbnail() {
      let yt_rx = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      let matches = this.videoLink.match(yt_rx)
      if(matches) {
        this.setYTThumbnail(matches[5])
      }

      let vm_rx = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
      if(this.videoLink.match(vm_rx))      {
        this.setVimeoThumbnail()
      }
    },
    setVimeoThumbnail() {
      vimeo.getThumbnail(this.videoLink, (response) => {
        this.thumbnail = response.thumbnail_url
        this.videoIframe = response.html
      })
    },
    setYTThumbnail(videoId) {
      this.videoIframe = `<iframe id="ytplayer" type="text/html" width="640" height="360"
                           src="https://www.youtube.com/embed/${videoId}?autoplay=1"
                           frameborder="0"/>`
      this.thumbnail = `https://i1.ytimg.com/vi/${videoId}/default.jpg`
    }
  }
}
</script>

<style scoped>

</style>